import styled from 'styled-components';
import { BaseStyle } from 'modules/Core/Common/Links/Base.styles';

const Anchor = styled.a`
  ${BaseStyle}
`;

export { Anchor };
